




































































  import Vue from 'vue';
  import {Donor} from "@/interfaces/donation/donor";
  import ValidationMixin from '@/mixins/validationMixin';
  import LabelMixin from '@/mixins/labelMixin';

  export default Vue.extend({
    props: {
      value: {
        type: Object as () => Donor,
      },
    },
    mixins: [ValidationMixin, LabelMixin],
    computed: {
      donor: {
        get():Donor {
          return this.value
        },
        set(val:Donor) {
          this.$emit('update:value', val)
        }
      },
    },
  });
